export default "__VITE_ASSET__0d407ee6__"